import React, { Component } from "react";
import Collection from "../../common/collection/collection";
import { Container, Row, Col, Image, Nav, Tab, Card, Dropdown, Modal, Button, Form, ListGroup } from "react-bootstrap";
import "./profile.scss";
import defaultPhoto from "../../images/default.png";
import { NavLink, withRouter } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCogs } from "@fortawesome/free-solid-svg-icons";
import IdentityService from "../../common/identityService";
import PhotoUpload from "../../common/photoUpload";
import ApiV2 from "../../common/apiV2"
import PropTypes from "prop-types";
import _ from "lodash";
import axios from "axios";

async function test() {
    // const accesstoken = 'eyJraWQiOiJtWHd0RUlFaVVXenVqbzJkQjArWmdCQk85SnpmV0V4OEx6SWxuNTBieFwvOD0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJmMWE3NjU5My1lNGM4LTRlNWMtYjFmZS02NTNlM2JlNzE5MDYiLCJldmVudF9pZCI6IjM3MDI0YjU4LTA0OTQtNDhlNS1hNmFjLWRlYTRjMTY3Yjc3OSIsInRva2VuX3VzZSI6ImFjY2VzcyIsInNjb3BlIjoiYXdzLmNvZ25pdG8uc2lnbmluLnVzZXIuYWRtaW4iLCJhdXRoX3RpbWUiOjE2Mjg2MzA0MDIsImlzcyI6Imh0dHBzOlwvXC9jb2duaXRvLWlkcC51cy1lYXN0LTEuYW1hem9uYXdzLmNvbVwvdXMtZWFzdC0xXzA4Q2Nnd3VNTyIsImV4cCI6MTYyODgwMjQ3OSwiaWF0IjoxNjI4Nzk4ODc5LCJqdGkiOiJkNDExNjIxOC03MzkwLTRhYWQtYTIwNS1iM2I1Y2FhZjZmOTYiLCJjbGllbnRfaWQiOiIyM3QwcDF2MmI2ZGFlaDF0OWxhMzBocHRlcSIsInVzZXJuYW1lIjoiZjFhNzY1OTMtZTRjOC00ZTVjLWIxZmUtNjUzZTNiZTcxOTA2In0.ZyUbQC2fIg_Kl9cVZUdtNwK6_o410QAECoD3qcofJ45AIMAdWLzWZieSHoyeqhZhj3AzAoEM0tGOm0wW2W5teDG7tqyQo8AiUEcVzhlnqM6yByIm_ZyZ4ejl553zlQ8gAIQatG53zgxo4WyvXdLZXeC_H02rXIf3M8P9mFiH2SduIHetZ0yINo0RcVP6Nqb75IkZPpN4E-xs_qrdn_YzaaRHJYzT1shHppLDs1J5jM-SGKZwvd1M-TKKrVTAcjhHlitnqVoV5nq3Bv_dLl_De5bgzURM1rgRPmzrjVp2kJg9kBA6_II5OxL-KETBRLxFHbSXr6am0pL8HZhx3tZ-1Q'
    const accesstoken = 'eyJraWQiOiJtWHd0RUlFaVVXenVqbzJkQjArWmdCQk85SnpmV0V4OEx6SWxuNTBieFwvOD0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJmMWE3NjU5My1lNGM4LTRlNWMtYjFmZS02NTNlM2JlNzE5MDYiLCJldmVudF9pZCI6IjM3MDI0YjU4LTA0OTQtNDhlNS1hNmFjLWRlYTRjMTY3Yjc3OSIsInRva2VuX3VzZSI6ImFjY2VzcyIsInNjb3BlIjoiYXdzLmNvZ25pdG8uc2lnbmluLnVzZXIuYWRtaW4iLCJhdXRoX3RpbWUiOjE2Mjg2MzA0MDIsImlzcyI6Imh0dHBzOlwvXC9jb2duaXRvLWlkcC51cy1lYXN0LTEuYW1hem9uYXdzLmNvbVwvdXMtZWFzdC0xXzA4Q2Nnd3VNTyIsImV4cCI6MTYyODgwMjQ3OSwiaWF0IjoxNjI4Nzk4ODc5LCJqdGkiOiJkNDExNjIxOC03MzkwLTRhYWQtYTIwNS1iM2I1Y2FhZjZmOTYiLCJjbGllbnRfaWQiOiIyM3QwcDF2MmI2ZGFlaDF0OWxhMzBocHRlcSIsInVzZXJuYW1lIjoiZjFhNzY1OTMtZTRjOC00ZTVjLWIxZmUtNjUzZTNiZTcxOTA2In0.ZyUbQC2fIg_Kl9cVZUdtNwK6_o410QAECoD3qcofJ45AIMAdWLzWZieSHoyeqhZhj3AzAoEM0tGOm0wW2W5teDG7tqyQo8AiUEcVzhlnqM6yByIm_ZyZ4ejl553zlQ8gAIQatG53zgxo4WyvXdLZXeC_H02rXIf3M8P9mFiH2SduIHetZ0yINo0RcVP6Nqb75IkZPpN4E-xs_qrdn_YzaaRHJYzT1shHppLDs1J5jM-SGKZwvd1M-TKKrVTAcjhHlitnqVoV5nq3Bv_dLl_De5bgzURM1rgRPmzrjVp2kJg9kBA6_II5OxL-KETBRLxFHbSXr6am0pL8HZhx3tZ-1Q'
    const headers = {
      "Authorization": `Bearer ${accesstoken}`,
      "Access-Control-Allow-Origin": "*"
    }
    const response = await axios.get(
      `https://ceu9nvuiw1.execute-api.us-east-1.amazonaws.com/api/v1/rec/`,
      {headers: headers}
    );
    return response;
  }

const DEFAULT_COUNTRY_PHOTO = {
    'United States': "https://www.virginholidays.co.uk/.imaging/Desktop/dam/0120998e-08f2-4805-b171-c71993976108.jpg",
    Germany: "https://www.studying-in-germany.org/wp-content/uploads/2013/02/how-to-study-in-germany.jpg",
    France: "https://media.cntraveler.com/photos/5d8cf7d5db6acf000833e6cc/master/pass/Eiffel-Tower_GettyImages-1060266626.jpg",
    Spain: "https://cdn.insuremytrip.com/resources/29337/spain_travel_insurance_seville.jpg",
    Greece: "https://www.azamara.com/sites/default/files/heros/jr-1-aug-2020-paros-greece-1800x1000_0.jpg",
    Italy: "https://cdn.cnn.com/cnnnext/dam/assets/170606121206-italy---travel-destination---shutterstock-517522957.jpg",
    Japan: "https://specials-images.forbesimg.com/imageserve/1179891725/960x0.jpg",
    Austrialia: "https://www.dbaudio.com/fileadmin/_processed_/1/8/csm_sydneyopera-house-au-2009-01_12a3f1a265.jpg",
    England: "https://news.itu.int/wp-content/uploads/2018/07/london-min-e1530887248858.jpg",
    China: "https://www.snopes.com/tachyon/2018/07/great_wall_of_china.jpg",
    Korea: "https://www.theinvisibletourist.com/wp-content/uploads/2019/08/featured_114.jpg",
    Thailand: "https://media.nomadicmatt.com/2019/11reasonsthailand.jpg",
    Default: "https://img.traveltriangle.com/blog/wp-content/tr:w-700,h-400/uploads/2018/09/swiss-alps.jpg"
}

class Profile extends Component {
    constructor(props) {
        super(props);

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.openEditModal = this.openEditModal.bind(this);
        this.closeEditModal = this.closeEditModal.bind(this);
        this.openShareModal = this.openShareModal.bind(this);
        this.closeShareModal = this.closeShareModal.bind(this);
        this.openUserSettingsModal = this.openUserSettingsModal.bind(this);
        this.closeUserSettingsModal = this.closeUserSettingsModal.bind(this);

        this.state = {
            userData: {},
            firstName: "",
            lastName: "",
            isPublic: false,
            photoURL: "",
            data: {},
            cities: [],
            countries: [],
            modalShow: false,
            setModalShow: false,
            sharelists: [],
            savedSharelists: [],
            flag: false,
            isOpen: false,
            isEditModalOpen: false,
            isShareModalOpen: false,
            isUserSettingsModalOpen: false,
            copySuccess: '',
            selectedSharelist: null,
            tempSharelist: null,
            registerClicked: false,
            successfulUpdate: false,
            checkboxChecked: false,
            following: 0,
            followers: 0,
            searchFriend: "",
            searchFriendResult: [],
            activeTab: "",
        };
    }

    async componentDidMount() {
        if (sessionStorage.getItem('activeTab') === "null" ||
            sessionStorage.getItem('activeTab') === null ||
            sessionStorage.getItem('activeTab') === "/logout") {
                this.setState({ activeTab: "Passport" });
        }
        else {
            this.setState({ activeTab: sessionStorage.getItem('activeTab') });
        }

        const isLoggedIn = await IdentityService.isLoggedIn();
        this.setState({isLoggedIn});

        const userData = ApiV2.getUserdataFromIdToken();
        this.setState({userData: userData});
        const firstName = userData['custom:firstName'];
        const lastName = userData['custom:lastName'];
        const photoURL = userData['custom:photoURL'];

        // Fetch from all external endpoints async
        const spotPromise = ApiV2.getUserRecommendations();
        const sharelistPromise = ApiV2.getSharelists();
        const savedSharelistsPromise = ApiV2.getSavedSharelists();
        const followersPromise = ApiV2.getFollowCount(userData.sub);
        const followingPromise = ApiV2.getFollowingCount(userData.sub);
        const userSettingsPromise = ApiV2.getUser(userData.sub);

        const spotsData = await spotPromise
            .then(result => {
                    return result.data;
            })
            .catch(error => {
                console.log("Unable to fetch spots.", error);
            });

        var cities = []
        var countries = []
        try {
            cities = [...new Set(spotsData.map(data => data.city))];
            countries = [...new Set(spotsData.map(data => data.country))];        
        } catch (error){
            console.log("Unable to organize spots by cities and countries.", error)
        }

        const sharelistsResponse = await sharelistPromise
            .then(result => {
                return result;
            })
            .catch(error => {
                console.log("Unable to fetch spots.", error);
            });
        const savedShareLists = await savedSharelistsPromise
            .then(result => {
                return result;
            })
            .catch(error => {
                console.log("Unable to fetch spots.", error);
                return {data: []}
            });

        var followersResponse = await followersPromise
            .then(result => {
                return result
            })
            .catch(error =>{
                console.log("Unable to followers count.", error);
            });

        var followingResponse = await followingPromise
            .then(result => {
                return result
            })
            .catch(error =>{
                console.log("Unable to following count.", error);
            });

        var userSettings = await userSettingsPromise
            .then(result => {
                return result
            })
            .catch(error =>{
                console.log("Unable to following count.", error);
            });
        
        this.setState({
            firstName: firstName.charAt(0).toUpperCase() + firstName.slice(1),
            lastName: lastName.charAt(0).toUpperCase() + lastName.slice(1),
            data: spotsData,
            photoURL: photoURL,
            cities: cities,
            countries: countries,
            sharelists: sharelistsResponse.data,
            savedSharelists: savedShareLists.data,
            following: followingResponse.Count,
            followers: followersResponse.Count,
            isPublic: userSettings.isPublic
        })
        this.props.setUserRecs(spotsData);


        var $testRes = await test();
        console.log("Test", $testRes);
    }

    async componentDidUpdate(prevProps, prevState) {
        if (prevState.flag !== this.state.flag) {
            try {
                var { data } = await ApiV2.getSharelists();
                this.setState({ sharelists: data })
            } catch (error) {
                console.log("Could not get new sharelist: ", JSON.stringify(error));
            }
            this.setState({ flag: false })
        }
        // Edit Sharelist
        if (prevState.registerClicked === false && this.state.registerClicked === true) {
            try {
                await ApiV2.updateSharelist(
                    this.state.selectedSharelist
                );
                this.setState({
                    successfulUpdate: true
                });
                this.closeModal();
                this.props.notifyInfo(
                    "Successfully updated Sharelist"
                );
            } catch (error) {
                console.log("Could not edit Sharelist: ", JSON.stringify(error));
                this.props.notifyFailure(
                    "Could not edit Sharelist"
                );
            }
            this.setState({
                registerClicked: false
            });
        }
        if (prevState.searchFriend !== this.state.searchFriend) {

            if (this.state.searchFriend === "") {
                this.setState({ searchFriendResult: [] });
            } else {
                try {
                    const response = await ApiV2.searchFriend(this.state.searchFriend, null, null);
                    this.setState({ searchFriendResult: response });
                } catch {

                }
            }
        }
    }

    openModal(sharelist) {
        this.setState({ isOpen: true, selectedSharelist: sharelist });
    }

    closeModal() {
        this.setState({ isOpen: false, selectedSharelist: null })
    }

    openEditModal() {
        let temp = JSON.parse(JSON.stringify(this.state.selectedSharelist));
        this.setState({ isEditModalOpen: true, tempSharelist: temp });
    }

    closeEditModal() {
        this.setState({ isEditModalOpen: false, tempSharelist: null });
    }

    openShareModal() {
        this.setState({ isShareModalOpen: true });
    }

    closeShareModal() {
        this.setState({
            isShareModalOpen: false,
            copySuccess: "",
            searchFriend: "",
            searchFriendResult: [],
        });
    }

    openUserSettingsModal() {
        this.setState({ isUserSettingsModalOpen: true });
    }

    closeUserSettingsModal() {
        this.setState({ isUserSettingsModalOpen: false });
    }

    copyToClipboard = (e) => {
        this.textArea.select();
        document.execCommand('copy');
        e.target.focus();
        this.setState({ copySuccess: 'Copied!' });
    };

    getSelectedSharelist() {
        if (this.state.selectedSharelist === null) {
            return "";
        } else {
            return this.state.selectedSharelist;
        }
    }

    getTempSharelist() {
        if (this.state.tempSharelist === null) {
            return "";
        } else {
            return this.state.tempSharelist;
        }
    }

    getProfilePhoto() {
        if (this.state.photoURL) {
            return (this.state.photoURL);
        } else {
            return (defaultPhoto);
        }
    }

    async deleteSharelist() {
        try {
            await ApiV2.deleteSharelist(this.state.selectedSharelist.id);
            this.setState({ flag: true, isOpen: false });
            this.closeModal();
            this.props.notifyInfo(
                "Successfully deleted sharelist"
            );
        } catch (error) {
            console.log("unable to delete error: ", JSON.stringify(error));
            this.props.notifyFailure(
                "Failed to delete Sharelist"
            );
        }
    }

    async shareSharelist(user) {
        try {
            const response = await ApiV2.shareSharelist(user, this.state.selectedSharelist);
            this.setState({ flag: true, isOpen: false });
            this.closeShareModal();
            this.closeModal();
            this.props.notifyInfo(
                `Shared collection with ${user.firstName}`
            );
        } catch (error) {
            console.log("Unable to share collection. Error: ", JSON.stringify(error));
            this.props.notifyFailure(
                "Failed to share collection"
            );
        }
    }

    async editSharelist() {
        try {
            const response = await ApiV2.updateSharelist(
                this.state.tempSharelist
            );

            this.state.selectedSharelist.name = JSON.parse(JSON.stringify(this.state.tempSharelist.name));
            this.state.selectedSharelist.caption = JSON.parse(JSON.stringify(this.state.tempSharelist.caption));

            this.setState({
                successfulUpdate: true,
                selectedSharelist: this.state.tempSharelist
            });
            this.closeEditModal();
            this.props.notifyInfo(
                "Successfully updated Sharelist"
            );
        } catch (error) {
            console.log("unable to edit error:", JSON.stringify(error));
            this.props.notifyFailure(
                "Failed to edit Sharelist"
            );
        }
    }

    async updateUserPrivacy() {
        try {
            const response = await ApiV2.updateUserPrivacy(
                this.state.isPublic
            );
            this.closeUserSettingsModal();
            this.props.notifyInfo(
                "Successfully updated privacy settings"
            );
        }
        catch (error) {
            console.log("unable to update error:", JSON.stringify(error));
            this.props.notifyFailure(
                "Failed to update privacy settings"
            );
        }
    }

    persistTabState(e) {
        sessionStorage.setItem('activeTab', e);
        this.setState({ activeTab: sessionStorage.getItem('activeTab') });
    }

    renderRecommendations() {
        const countryCard = this.state.countries.map(country => {
            const places = _.filter(this.state.data, place => {
                return place.country === country;
            });
            var photo = DEFAULT_COUNTRY_PHOTO.Default;
            if (country in DEFAULT_COUNTRY_PHOTO) {
                photo = DEFAULT_COUNTRY_PHOTO[country]
            }
            return (
                <>
                    <Card className="country-cards mb-1">
                        <NavLink to="/profile/listRecommendation" onClick={() => this.props.setCurrentRecList(country, places)}>
                            <Card.Img className="country-card-image" variant="top" src={photo} />
                        </NavLink>
                        <Card.Body className="pl-0 pr-0 pt-1 pb-1">
                            {country}
                            <p className="place-text text-secondary mb-0">{places.length} Spots</p>
                        </Card.Body>
                    </Card>
                </>
            );
        });
        return countryCard
    }

    renderFriendSearch() {
        const users = this.state.searchFriendResult?.map(user => {
            return (
                <>
                    <ListGroup.Item key={user.userId} onClick={async () => await this.shareSharelist(user)} className="position-absolute w-100 py-1 px-2" style={{ zIndex: 1 }}>
                        <Row className="text-center">
                            <Col xs={3}>
                                <Image className="profile-photo" src={user.photoURL} roundedCircle />
                            </Col>
                            <Col xs={9} className="p-0 d-flex justify-content-center align-items-center">
                                <Row>
                                    <span className="friend-name">{user.firstName.charAt(0).toUpperCase() + user.firstName.slice(1) + " " + user.lastName.charAt(0).toUpperCase() + user.lastName.slice(1)}</span>
                                </Row>
                            </Col>
                        </Row>
                    </ListGroup.Item>
                </>
            );
        });
        return users
    }

    renderSharelists() {
        const sharelistCards = this.state.sharelists.map(sharelist => {
            return (
                <Collection
                    collection={sharelist}
                    collectionPath="/profile/viewSharelist"
                    collectionType="OWNED"
                    setSelectedSharelist={this.props.setSelectedSharelist}
                    openModal={this.openModal}
                />
            );
        });
        return sharelistCards;
    }

    renderSavedSharelists() {
        const sharelistCards = this.state.savedSharelists?.map(sharelist => {
            return (
                <Collection
                    collection={sharelist}
                    collectionType="SAVED"
                    collectionPath={`/user/sharelist/${sharelist.id}`}
                    setSelectedSharelist={this.props.setSelectedSharelist}
                    openModal={this.openModal}
                />
            );
        });
        return sharelistCards;
    }

    renderModal() {
        return (
            <Modal className="p-2" show={this.state.isOpen} onHide={this.closeModal} centered>
                <Modal.Header>
                    <Modal.Title className="modal-title">{this.state.selectedSharelist?.name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Button onClick={this.openShareModal} className="blue" variant="light" block>
                        Share
                        </Button>
                    <Button onClick={this.openEditModal} className="blue" variant="light" block>
                        Edit
                        </Button>
                    <Button onClick={async () => await this.deleteSharelist()} variant="danger" block>
                        Delete
                        </Button>
                    <Button onClick={this.closeModal} className="blue" variant="light" block>
                        Cancel
                        </Button>
                </Modal.Body>
            </Modal>
        );
    }

    renderShareModal() {
        return (
            <Modal className="p-2" show={this.state.isShareModalOpen} onHide={this.state.closeShareModal} centered>
                <Modal.Header>
                    <Modal.Title className="modal-title">{this.state.selectedSharelist?.name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group as={Row}>
                            <Col md={8}>
                                <Form.Label>
                                    <b>Share this sharelist with your friends:</b>
                                </Form.Label>
                                <Form.Control
                                    placeholder="Search for friends"
                                    value={this.state.searchFriend}
                                    onChange={event => {
                                        this.setState({
                                            searchFriend: event.target.value
                                        });
                                    }}
                                />
                                <ListGroup className="position-relative">
                                    {this.renderFriendSearch()}
                                </ListGroup>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-1">
                            <Col md={8}>
                                <Form.Label>
                                    <b>Or share using the link below:</b>
                                </Form.Label>
                                <Form.Control
                                    ref={(textarea) => this.textArea = textarea}
                                    value='https://traceapp.com/placeholderLink'
                                />
                            </Col>
                        </Form.Group>

                        <Button onClick={this.copyToClipboard} variant="primary" block>
                            Copy Link
                        </Button>
                        {this.state.copySuccess}

                        <Button onClick={this.closeShareModal} className="blue" variant="light" block>
                            Cancel
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
        )
    }

    renderEditModal() {
        return (
            <Modal className="p-2" show={this.state.isEditModalOpen} onHide={this.closeEditModal} centered>
                <Modal.Body>
                    <Form>
                        <Form.Group as={Row}>
                            <Col md={8}>
                                <Form.Label className="mb-0"><b>Name: </b></Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Sharelist name"
                                    value={this.getTempSharelist().name}
                                    onChange={event => {
                                        let newSharelist = this.state.tempSharelist;
                                        newSharelist.name = event.target.value;
                                        this.setState({
                                            tempSharelist: newSharelist
                                        });
                                    }}
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-1">
                            <Col md={8}>
                                <Form.Label className="mb-0"><b>Caption: </b></Form.Label>
                                <Form.Control
                                    as="textarea" rows="3"
                                    maxLength="280"
                                    value={this.getTempSharelist().caption}
                                    placeholder="Caption (280 characters limit)"
                                    onChange={event => {
                                        let newSharelist = this.getTempSharelist();
                                        newSharelist.caption = event.target.value;
                                        this.setState({
                                            tempSharelist: newSharelist
                                        });
                                    }}
                                    onKeyPress={e => {
                                        if (e.key === "Enter") {
                                            this.onRegisterClicked();
                                        }
                                    }}
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group className="mb-1">
                            <Form.Check
                                type="checkbox"
                                label="Make Sharelist private"
                                defaultChecked={(!this.getTempSharelist().isPublic)}
                                onChange={event => {
                                    let newSharelist = this.getTempSharelist();
                                    newSharelist.isPublic = !newSharelist.isPublic;
                                    this.setState({
                                        tempSharelist: newSharelist
                                    });
                                }}
                            />
                        </Form.Group>

                        <Button variant="primary" onClick={async () => await this.editSharelist()} block>
                            Save
                        </Button>

                        <Button onClick={this.closeEditModal} className="blue" variant="light" block>
                            Cancel
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
        );
    }

    renderSettingsModal() {
        return (
            <Modal className="p-2" show={this.state.isUserSettingsModalOpen} onHide={this.closeUserSettingsModal} centered>
                <Modal.Header>
                    <Modal.Title className="modal-title">User Settings</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form className="p-2">
                        <Form.Group className="mb-1">
                            <Form.Check
                                type="checkbox"
                                label="Private Account"
                                defaultChecked={!this.state.isPublic}
                                onChange={event => {
                                    let isPub = this.state.isPublic;
                                    isPub = !isPub;
                                    this.setState({
                                        isPublic: isPub
                                    });
                                }}
                            />
                        </Form.Group>
                        <Button variant="primary" onClick={async () => await this.updateUserPrivacy()} block>
                            Save
                        </Button>

                        <Button onClick={() => this.setState({ isUserSettingsModalOpen: false })} className="blue" variant="light" block>
                            Cancel
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
        );
    }

    render() {
        return (
            <Container className="child-container">
                {this.renderModal()}
                {this.renderEditModal()}
                {this.renderShareModal()}
                {this.renderSettingsModal()}

                <Tab.Container activeKey={this.state.activeTab} onSelect={(e) => this.persistTabState(e)}>
                    <Row id="profile-header" className="align-items-center mt-2">
                        <Col xs="4" className="align-middle">
                            <Row className="justify-content-center">
                                <Dropdown>
                                    <Dropdown.Toggle className="p-1" variant="link">
                                        <Image id="profile-photo" src={this.getProfilePhoto()} roundedCircle></Image>
                                        <FontAwesomeIcon className="setting-icon fa-md" icon={faCogs} />
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => this.setState({ isUserSettingsModalOpen: true })}>Settings</Dropdown.Item>
                                        <Dropdown.Item onClick={() => this.setState({ modalShow: true })}>Change Photo</Dropdown.Item>
                                        <Dropdown.Item onClick={() => window.open("https://togoldordashtseren.typeform.com/to/SAgKzOUU", "_blank")}>Take survey</Dropdown.Item>
                                        <Dropdown.Item onClick={() => window.open("https://togoldordashtseren.typeform.com/to/LWwx7gS1", "_blank")}>Report bug</Dropdown.Item>
                                        <Dropdown.Item href="/logout">Logout</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Row>
                        </Col>
                        <Col xs="8" className="pl-0">
                            <Row className="justify-content-center">
                                <span className="font-weight-bold">
                                    <span>{this.state.firstName}</span> <span>{this.state.lastName}</span>
                                </span>
                            </Row>
                            <Row className="justify-content-center" onClick={() => this.props.history.push(`/profile/friends/${this.state.userData.sub}`)}>
                                <span className="follow-row">
                                    <span className="font-weight-bold">{this.state.following}</span> Following | <span className="font-weight-bold">{this.state.followers}</span> Followers
                                </span>
                            </Row>
                            <Row className="justify-content-center profile-info-count">
                                <Col>
                                    <Row className="font-weight-bold justify-content-center">
                                        <span>{this.state.cities.length}</span>
                                    </Row>
                                    <Row className="justify-content-center">
                                        Cities
                                    </Row>
                                </Col>
                                <Col>
                                    <Row className="font-weight-bold justify-content-center">
                                        <span>{this.state.data.length ? this.state.data.length : 0}</span>
                                    </Row>
                                    <NavLink to="/profile/listRecommendation" onClick={() => this.props.setCurrentRecList("My Spots", this.state.data)}>
                                        <Row className="justify-content-center">
                                            Spots
                                        </Row>
                                    </NavLink>
                                </Col>
                                <Col>
                                    <Row className="font-weight-bold justify-content-center">
                                        <span>{this.state.sharelists.length}</span>
                                    </Row>
                                    <Row className="justify-content-center">
                                        Collections
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className="mt-2 mb-2">
                        <Col className="align-middle">
                            <Nav variant="pills" className="flex-row justify-content-center">
                                <Nav.Item>
                                    <Nav.Link className="profile-tab" eventKey="Passport">Passport</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link className="profile-tab" eventKey="Collections">Collections</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link className="profile-tab" eventKey="Saved">Saved</Nav.Link>
                                </Nav.Item>
                            </Nav>
                        </Col>
                    </Row>
                    <Row>
                        <Tab.Content id="profile-content">
                            <ChangeProfilePhotoModal
                                show={this.state.modalShow}
                                onHide={() => this.setState({ modalShow: false })}
                                userId={this.state.userData.sub}
                                notifyInfo={this.props.notifyInfo}
                                notifyFailure={this.props.notifyFailure}
                                imageUrl={this.state.photoURL}
                            />
                            <Tab.Pane eventKey="Passport">
                                <Container className="content-container profile-container">
                                    <>{this.renderRecommendations()}</>
                                </Container>
                            </Tab.Pane>
                            <Tab.Pane eventKey="Collections">
                                <Container className="content-container profile-container">
                                    <Button href="/createSharelist" className="mb-2">Create List</Button>
                                    {this.renderSharelists()}
                                </Container>
                            </Tab.Pane>
                            <Tab.Pane eventKey="Saved">
                                <Container className="content-container profile-container">
                                    <Button href="/getUserSharedSharelists" className="mb-2">Pending</Button>
                                    {this.renderSavedSharelists()}
                                </Container>
                            </Tab.Pane>
                        </Tab.Content>
                    </Row>
                </Tab.Container>
            </Container>
        );
    }
}

function ChangeProfilePhotoModal(props) {
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Change profile photo
          </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container className="d-flex justify-content-center">
                    <PhotoUpload
                        className="mx-0"
                        onHide={props.onHide}
                        // setImageUrl={imageUrl => {
                        //   this.setImageUrl(imageUrl);
                        // }}
                        imageUrl={props.imageUrl}
                        notifyInfo={props.notifyInfo}
                        notifyFailure={props.notifyFailure}
                        idPrefix={props.userId}
                        photoType="PROFILE"
                    />
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onHide}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default withRouter(Profile);

Profile.propTypes = {
    userRecs: PropTypes.array.isRequired,
    setUserRecs: PropTypes.func.isRequired,
    setCurrentRecList: PropTypes.func.isRequired,
    setSelectedSharelist: PropTypes.func.isRequired,
    notifyInfo: PropTypes.func.isRequired,
    notifyFailure: PropTypes.func.isRequired
};
